module.exports = __webpack_public_path__ + "static/media/dom.5bb37f17.svg";